// import React, { useState, useRef, Fragment } from "react";
// import { useTransition, useSpring, useChain, config } from "react-spring";
// import data from "./data";
// import { MenuOutlined } from "@ant-design/icons";
// import "antd/dist/antd.css";
// import "./styles.css";
// import { MenuIcon } from "../../components/MenuIcon/MenuIcon";
// import { MenuModal } from "./MenuModal";

// export default function Menu() {
//   const [open, setOpen] = useState(false);

//   const springRef = useRef();
//   const { height, width, opacity, ...rest } = useSpring({
//     ref: springRef,
//     config: config.stiff,
// from: {
//   height: open ? "0%" : "85vh",
//   width: open ? "0%" : "70vh",
//   background: "white",
//   display: open ? "none" : "flex",
// },
// to: {
//   height: open ? "85vh" : "0%",
//   width: open ? "70vh" : "0%",
//   background: open ? "white" : "white",
//   display: open ? "flex" : "none",
// },
//   });

//   const transRef = useRef();
//   const transitions = useTransition(open ? data : [], (item) => item.name, {
//     ref: transRef,
//     unique: true,
//     trail: 400 / data.length,
//     from: { opacity: 0, transform: "scale(0)" },
//     enter: { opacity: 1, transform: "scale(1)" },
//     leave: { opacity: 0, transform: "scale(0)" },
//   });

//   // This will orchestrate the two animations above, comment the last arg and it creates a sequence
//   useChain(open ? [springRef, transRef] : [transRef, springRef], [0, open ? 0.1 : 0.6]);

// return (
//   <Fragment>
//     <MenuIcon>
//       <div className="menuIcon" onClick={toggleOpen}>
//         <MenuOutlined style={{ color: "ghostwhite" }} />
//       </div>
//     </MenuIcon>
//     {MenuModal(setOpen, open, rest, width, height, transitions)}
//   </Fragment>
// );

// function toggleOpen() {
//   return setOpen((open) => !open);
// }
// }

import React, { useState, Fragment } from "react";
import { useTransition, useSpring, useChain, config, useSpringRef } from "@react-spring/web";
import { MenuOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import "./styles.css";
import { MenuIcon } from "../../components/MenuIcon/MenuIcon";
import { MenuModal } from "./MenuModal";

import data from "./data";
// import styles from './styles.module.css'

export default function Menu({ isDarkTheme }) {
  const [open, setOpen] = useState(false);

  const springApi = useSpringRef();
  const { height, width, opacity, ...rest } = useSpring({
    ref: springApi,
    config: config.stiff,
    from: {
      height: open ? "0%" : "85vh",
      width: open ? "0%" : "70vh",
      background: "white",
      display: open ? "none" : "flex",
    },
    to: {
      height: open ? "85vh" : "0%",
      width: open ? "70vh" : "0%",
      background: open ? "white" : "white",
      display: open ? "flex" : "none",
    },
  });

  const transApi = useSpringRef();
  const transitions = useTransition(open ? data : [], {
    ref: transApi,
    trail: 400 / data.length,
    from: { opacity: 0, scale: 0 },
    enter: { opacity: 1, scale: 1 },
    leave: { opacity: 0, scale: 0 },
  });

  // This will orchestrate the two animations above, comment the last arg and it creates a sequence
  useChain(open ? [springApi, transApi] : [transApi, springApi], [0, open ? 0.1 : 0.6]);

  return (
    <Fragment>
      <MenuIcon>
        <div className="menuIcon" onClick={toggleOpen}>
          <MenuOutlined style={{ color: isDarkTheme ? "black" : "ghostwhite" }} />
        </div>
      </MenuIcon>
      {MenuModal(setOpen, open, rest, width, height, transitions)}
    </Fragment>
  );

  function toggleOpen() {
    return setOpen((open) => !open);
  }
}
